import { useEffect, useState } from "react";
import ReCAPTCHA from "react-google-recaptcha";
import Swal from "sweetalert2";
import Header from "../header";
import { Link } from "react-router-dom";
import styles from "../home/index.module.css";
import AuthServices from "../../services/AuthServices";
import { logo, LogoImage } from "../imagepath";
const AboutUs = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });
  const [isCaptchaVerified, setIsCaptchaVerified] = useState(false);

  const handleCaptchaChange = (value) => {
    if (value) {
      setIsCaptchaVerified(true);
    }
  };
  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSendMessage = async (e) => {
    e.preventDefault();

    try {
      const response = await AuthServices.sendEmail(formData);
      console.log("response", response);
      Swal.fire({
        title: "Success!",
        text: "Sucessfully Sent!",
        icon: "success",
        confirmButtonText: "OK",
      });
      setFormData({ name: "", email: "", message: "" });
    } catch (error) {
      Swal.fire({
        text: "Failed to Send!",
        icon: "info",
        confirmButtonText: "OK",
      });
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div className="main-wrapper">
      <Header />
      <section>
        <h1
          className="text-center align-content-center"
          style={{ height: "300px", background: "#00112B", color: "white" }}
        >
          A Legacy of Protection, Now for Education
        </h1>
        <div className="text-center" style={{ marginTop: "-100px" }}>
          <img
            src={require("../../assets/img/avatar.JPG")}
            className="w-full"
            style={{ maxWidth: "500px", width: "90%" }}
          ></img>
        </div>
        <img
          className={styles.usLogo}
          src={require("../../assets/img/logo/Seal_of_the_United_States_Department_of_Homeland_Security.svg_-300x300.png")}
          style={{
            maxWidth: "200px",
            position: "absolute",
            top: "40vh",
            left: "5vw",
          }}
        />
        <img
          className={styles.usLogo}
          src={require("../../assets/img/logo/Seal_of_the_United_States_Department_of_State.svg_-300x300.png")}
          style={{
            maxWidth: "200px",
            position: "absolute",
            top: "80vh",
            left: "5vw",
          }}
        />
        <img
          className={styles.usLogo}
          src={require("../../assets/img/logo/2000px-US-FEMA-Pre2003Seal.svg_-300x300.png")}
          style={{
            maxWidth: "200px",
            position: "absolute",
            top: "40vh",
            right: "5vw",
          }}
        />
        <img
          className={styles.usLogo}
          src={require("../../assets/img/logo/dod-logo-300x300.jpg")}
          style={{
            maxWidth: "200px",
            position: "absolute",
            top: "80vh",
            right: "5vw",
          }}
        />

        <p className="mx-auto" style={{ maxWidth: "700px", width: "90%" }}>
          AngelWatch was founded in 2015 with a singular mission: to bring
          proven government-level emergency preparedness to the environments
          that care for our youngest citizens. <br /> <br />
          Our founder, Mr. Dave Vitalli, is a Department of Defense contractor
          and CEO of Vortek International. Since 1994, he has worked with every
          U.S. presidential administration, advised on the creation of the
          Department of Homeland Security, and helped safeguard agencies and
          government personnel across 22 world governments. <br />
          <br />
          After 9/11, emergency planning was redesigned for federal buildings,
          but the same urgency wasn’t extended to schools or daycares.
          AngelWatch was created to fix that. Mr. Vitalli used the same
          government-grade standards and designed AngelWatch to be the first
          emergency management certification platform that matches the
          preparedness of U.S. security agencies. <br />
          <br />
          Now, every school and center in the U.S. can access that same
          protection. AngelWatch is built for educators—but developed by
          national defense experts.
        </p>
        <div className={styles.cta}>
          <h1 className={`text-white ${styles.cta__title}`}>
            Protect your children. Protect your staff. Stay compliant.
          </h1>
          <Link to="/getCertified">
            <button className={styles.cta__button}>
              Get Certified Now -&gt;
            </button>
          </Link>
        </div>
      </section>

      <section className={styles.contact__section}>
        <h1 className={styles.contact__heading}>Contact Us</h1>
        <div className={styles.contact}>
          <div>
            <h2 className={styles.contact__title}>
              For more information contact us
            </h2>
            <div>
              <img src={LogoImage} className={styles.contact__logoImg}></img>
            </div>
            <div>
              <div className={styles.contact__list}>
                <img
                  src={require("../../assets/img/email.png")}
                  className={styles.contact__img}
                ></img>
                <p className={styles.contact__item}>Edu@AngelWatch.org</p>
              </div>
              <div className={styles.contact__list}>
                <img
                  src={require("../../assets/img/call.png")}
                  className={styles.contact__img}
                ></img>
                <p className={styles.contact__item}>+1 800-381-6794</p>
              </div>
            </div>
          </div>
          <div className={styles.contact__form}>
            <div>
              <p>Your name</p>
              <input
                type="text"
                className={styles.contact__input__info}
                placeholder="John Smith"
                name="name"
                value={formData.name}
                onChange={handleChange}
              ></input>
            </div>
            <div>
              <p>Your email</p>
              <input
                type="email"
                name="email"
                className={styles.contact__input__info}
                placeholder="abc@gmail.com"
                value={formData.email}
                onChange={handleChange}
              ></input>
            </div>
            <div className={styles.contact__message__form}>
              <p>Your message</p>
              <textarea
                type="text"
                name="message"
                className={styles.contact__message__input}
                value={formData.message}
                onChange={handleChange}
              ></textarea>
            </div>
            <button
              style={{ marginBottom: "20px" }}
              onClick={handleSendMessage}
              disabled={!isCaptchaVerified}
            >
              Send Message
            </button>
            <ReCAPTCHA
              sitekey={process.env.REACT_APP_SITE_KEY}
              className={`${styles.captcha}`}
              onChange={handleCaptchaChange}
            />
          </div>
        </div>
      </section>

      {/* Master Skills */}
      {/* /Master Skills */}
      <section className="d-flex flex-column">
        <div className={styles.footerTop}>
          <div className={styles.footerSection}>
            <img className={styles.footerImage} src={logo} />
            <p className={styles.footerDes}>
              All of our techniques, trainings, equipment, software, hardware,
              and instructional materials are classified and proprietary to the
              AngelWatch Foundation. We do not publicly disclose our teaching
              methodologies. This confidentiality is essential to ensure the
              ongoing safety and security of our centers, staff, and the
              children entrusted to our care. By continuously improving,
              adapting, and evolving our systems, we remain one step
              ahead—proactively closing any potential gaps and ensuring every
              base is covered.
            </p>
          </div>

          <div className={styles.footerLoginSection}>
            <p className={styles.footerTitle}>School</p>
            <Link to="/login">
              <a className={styles.footerLink1}>Login</a>
            </Link>
            <Link to="/selectregister">
              <a className={styles.footerLink1}>Register</a>
            </Link>
          </div>

          <div className={styles.footerSection}>
            <p className={styles.footerTitle}>Newsletter</p>
            <input
              className={styles.newsLetter}
              placeholder="Enter your email address"
              type="text"
            />
            <p className={styles.footerLink1}>
              Hampton Reserve Drive, Brentwood tennessee, 37027
            </p>
            <p className={styles.footerLink1}>Edu@AngelWatch.org</p>
            <p className={styles.footerLink1}>+1 800-381-6794</p>
          </div>
        </div>
        <div className={styles.footerBottom}>
          <div className={styles.footerBottomLeft}>
            <p className={styles.footerLink}>Term</p>
            <p className={styles.footerLink}>|</p>
            <p className={styles.footerLink}>Privacy</p>
          </div>
          <div className={styles.footerBottomRight}>
            <p className={styles.footerLink}>
              © 2025 AngelWatch LMS. All rights reserved.
            </p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default AboutUs;
